import React from "react";
import { formatUid } from "../../../utils";
import EyeButton from "./EyeButton";

export default function WidgetUidWithShortcut({ feature, onClick }) {
  let { uid, rds_pms_no, RDS_PMS_NO } = feature;
  uid = uid || rds_pms_no || RDS_PMS_NO;

  let { latitude, longitude, lat, lon, LAT, LON } = feature;
  latitude = latitude || lat || LAT;
  longitude = longitude || lon || LON;

  const isUnusablePosition =
    isUnusableValue(latitude) || isUnusableValue(longitude);

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <span>{formatUid(uid)}</span>
      {!isUnusablePosition && (
        <EyeButton
          onClick={() => onClick({ ...feature, uid, latitude, longitude })}
        />
      )}
      {/* <Button
            onClick={() => onClick({ ...feature, uid, latitude, longitude })}
            size={"small"}
            shape={"circle-outline"}
            icon={"eye"}
            style={{ marginLeft: 8 }}
          /> */}
    </div>
  );
}

function isUnusableValue(value) {
  return !value || value === 0 || value === "";
}
